import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";

interface FormCardProps {
  title: string | React.ReactNode;
  description?: string;
  children: React.ReactNode;
}

/**
 * Form wrapper card with title and description
 */
export function FormCard({ title, description, children }: FormCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
